import React from 'react';
import { HashRouter, Route, Switch, Router } from 'react-router-dom';
import QuitApplication from './views/quitApplication/quitApplication';
import NewHome from './views/newHome/newCurHome.js';
import { Provider, KeepAlive } from 'react-keep-alive';
// import { HashRouter, Route, Router } from 'react-router-dom';
// import { getCookie } from './util/cookie';
import loadable from './util/loadable';
import ErrorToHomePage from './components/errorPage/errorPage';
// const Home = loadable(() => import('./views/Home/Home')); // 首页
const AllDesc = loadable(() => import('./views/desc/desc')); // 详情简介
// const FilterPage = loadable(() => import('./views/filterPage/filterPage')); // 筛选海信、三星版本
const FilterPage = loadable(() => import('./views/newFilterPage/newFilterPage'));
const FilterPageLG = loadable(() => import('./views/filterPageLG/filterPageLG')); // 筛选LG版本
const Search = loadable(() => import('./views/search/search')); // 查询
// const WatchHistory = loadable(() => import('./views/watchHistory/watchHistory')); // 观看历史
const WatchHistory = loadable(() => import('./views/history/history.js')); // 观看历史
const searchResult = loadable(() => import('./views/searchResult/searchResult')); // 查询结果
const SetUp = loadable(() => import('./views/setUp/setUp')); // 设置
const SoftwareInfo = loadable(() => import('./views/softwareInfo/softwareInfo')); // 关于我们
const HelpFeedback = loadable(() => import('./views/helpFeedback/helpFeedback')); // 帮助反馈
const Login = loadable(() => import('./views/login/login')); // 登录
const PhoneLogin = loadable(() => import('./views/phoneLogin/phoneLogin')); // 手机登录
const GuidePages = loadable(() => import('./views/guidePages/guidePages')); // 登录引导页
const Register = loadable(() => import('./views/register/register')); // 注册
const SelectArea = loadable(() => import('./views/selectArea/selectArea')); // 选择登录地区
const PhonePassword = loadable(() => import('./views/phonePassword/phonePassword')); // 输入登录密码
const EmailLogin = loadable(() => import('./views/emailLogin/emailLogin')); // 邮箱登录
const OrderVip = loadable(() => import('./views/orderVip/orderVip')); // 订购续费
const OpenVipRes = loadable(() => import('./views/openVipRes/openVipRes')); // 开通会员结果，主要针对astro侧开通后返回回来页面
const SignOut = loadable(() => import('./views/signOut/signOut')); // 退出登录
// const QuitApplication = loadable(() => import('./views/quitApplication/quitApplication')); // 退出应用
const LimitScenes = loadable(() => import('./views/limitScenes/limitScenes')); // 超前点播
const NoBuyScenes = loadable(() => import('./views/noBuyScenes/noBuyScenes')); // 未购买场景报错
const TermsService = loadable(() => import('./views/termsService/termsService')); // 服务条款
const PrivacyPolicy = loadable(() => import('./views/privacyPolicy/privacyPolicy')); // 隐私协议
const LiveStreaming = loadable(() => import('./views/liveStreaming/liveStreaming')); // 直播
const LiveStreamingFull = loadable(() => import('./views/liveStreamingFull/liveStreamingFull')); // 直播全屏页
const Loading = loadable(() => import('./views/loading/loading')); // loading页
const BackLoading = loadable(() => import('./views/backLoading/backLoading')); // 返回loading页
const Activity = loadable(() => import('./views/activity/activity')); // 跳活动拦截
// const Particular = loadable(() => import('./views/particular/particular')); // 最新详情页
const Particular = loadable(() => import('./views/newParticular/newParticular')); // 最新详情页
const FullScreen = loadable(() => import('./views/fullscreen/fullScreen')); // 全屏播放页
const ParentGuidelines = loadable(() => import('./views/parentGuidelines/parentGuidelines')); // 家长指引页
const TermsPolicy = loadable(() => import('./views/termsPolicy/termsPolicy')); // 服务条款和隐私协议
// const vChannelId = localStorage.getItem('v_channel_id');
// const isNeedNewHome = vChannelId === '16614' || vChannelId === '16562' || vChannelId === '16563';

const BasicRoute = () => (
  <HashRouter history={Router}>
    <Provider>
      <Switch>
        {/* <Route exact path="/" component={Home} /> */}
        {/* <Route exact path="/" component={HomePage} /> */}
        {
          // isNeedNewHome ?
          <Route exact path="/">
            <KeepAlive name="/">
              <NewHome />
            </KeepAlive>
          </Route>
          // :
          // <Route exact path="/" component={Home} />
        }
        <Route exact path="/allDesc/:cid/:type?" component={AllDesc} />
        <Route exact path="/filterPage/:first_category/:sort?" component={FilterPage} />
        {/* <KeepAlive name='/filterPage/:first_category/:sort?'> */}
        {/* <Route exact path="/filterPage/:first_category/:sort?"> */}
        {/* <KeepAlive name='/filterPage/:first_category/:sort?'> */}
        {/* <FilterPage/> */}
        {/* </KeepAlive> */}
        {/* </Route> */}
        {/* </KeepAlive> */}
        <Route exact path="/filterPageLG/:first_category/:sort?" component={FilterPageLG} />
        <Route exact path="/search/:sourcePage?/:id?/:page?/:filterId?" component={Search} />
        <Route exact path="/watchHistory/" component={WatchHistory} />
        <Route exact path="/searchResult/:params" component={searchResult} />
        <Route exact path="/setUp/" component={SetUp} />
        <Route exact path="/softwareInfo/" component={SoftwareInfo} />
        <Route exact path="/helpFeedback/" component={HelpFeedback} />
        <Route exact path="/login/:type?" component={Login} />
        <Route exact path="/guidePages/" component={GuidePages} />
        <Route exact path="/register/:type?" component={Register} />
        <Route exact path="/phoneLogin/:areaId?" component={PhoneLogin} />
        <Route exact path="/selectArea/:areaId" component={SelectArea} />
        <Route exact path="/phonePassword/:phone/:type/:areaCode?" component={PhonePassword} />
        <Route exact path="/emailLogin/" component={EmailLogin} />
        <Route exact path="/orderVip/:source1?/:cid?/:vid?" component={OrderVip} />
        <Route exact path="/openVipRes" component={OpenVipRes}></Route>
        <Route exact path="/signOut/" component={SignOut} />
        <Route exact path="/quitApplication/" component={QuitApplication} />
        <Route exact path="/limitScenes/:cid?/:vid?" component={LimitScenes} />
        <Route exact path="/noBuyScenes/" component={NoBuyScenes} />
        <Route exact path="/termsService/" component={TermsService} />
        <Route exact path="/privacyPolicy/" component={PrivacyPolicy} />
        <Route exact path="/LiveStreaming/:pid" component={LiveStreaming} />
        <Route exact path="/LiveStreamingFull/:pid/:streamId?" component={LiveStreamingFull} />
        <Route exact path="/Loading/:cid/:sourcePage?/:filterId?/:type?" component={Loading} />
        <Route exact path="/BackLoading/:cid/:sourcePage?" component={BackLoading} />
        <Route exact path="/Activity/" component={Activity} />
        <Route exact path="/Particular/:cid/:sourcePage?/:filterId?/" component={Particular} />
        <Route
          exact
          path="/FullScreen/:vid/:cid?/:sourcePage?/:filterId?/"
          component={FullScreen}
        />
        <Route exact path="/parentGuidelines/" component={ParentGuidelines} />
        <Route exact path="/termsPolicy/" component={TermsPolicy} />
        <Route exact path="/pageErr/" component={ErrorToHomePage} />
        {/* <Route exact path="/hahaha" component={NewHome} /> */}
        {/* <Route exact path="/filterPage/:first_category/:sort?" 
        children={({ match, ...restProps }) => {
          // eslint-disable-next-line
          restProps.match = match;
          const isCache = getCookie('isCache');
          if (match && (isCache === 'noCache' || !isCache)) {
            return React.createElement(FilterPage, restProps);
            // eslint-disable-next-line
          } else if (isCache === 'cache'){
            return (<FilterPage {...restProps}/>);
          } else {
            return null;
          }
        }
      } />
      <Route exact path="/filterPageLG/:first_category/:sort?" 
        children={({ match, ...restProps }) => {
          // eslint-disable-next-line
          restProps.match = match;
          const isCache = getCookie('isCacheLG');
          if (match && (isCache === 'noCache' || !isCache)) {
            return React.createElement(FilterPageLG, restProps);
            // eslint-disable-next-line
          } else if (isCache === 'cache'){
            return (<FilterPageLG {...restProps}/>);
          } else {
            return null;
          }
        }
      } /> */}
      </Switch>
    </Provider>
  </HashRouter>
);

export default BasicRoute;
